import ACTIVE_WITH_NOTIFICATIONS_ICON from '!svg-inline?removeSVGTagAttrs=false&removeTags=true!images/svg/status-icons/active-with-notifications.svg'
import ACTIVE_WITHOUT_NOTIFICATIONS_ICON from '!svg-inline?removeSVGTagAttrs=false&removeTags=true!images/svg/status-icons/active-without-notifications.svg'
import AWAY_WITH_NOTIFICATIONS_ICON from '!svg-inline?removeSVGTagAttrs=false&removeTags=true!images/svg/status-icons/away-with-notifications.svg'
import AWAY_WITHOUT_NOTIFICATIONS_ICON from '!svg-inline?removeSVGTagAttrs=false&removeTags=true!images/svg/status-icons/away-without-notifications.svg'
import AUTO_AWAY_WITH_NOTIFICATIONS_ICON from '!svg-inline?removeSVGTagAttrs=false&removeTags=true!images/svg/status-icons/auto-away-with-notifications.svg'
import AUTO_AWAY_WITHOUT_NOTIFICATIONS_ICON from '!svg-inline?removeSVGTagAttrs=false&removeTags=true!images/svg/status-icons/auto-away-without-notifications.svg'

export const AvailabilityStatus = {
  ACTIVE: 'AVAILABLE',
  AWAY: 'OFFLINE',
  ON_CALL: 'ON_CALL'
}

export const NotificationSnoozeStatus = {
  ON: 'SNOOZE_ON',
  OFF: 'SNOOZE_OFF'
}

export const AvailabilityStatusIcons = [
  {
    availabilityStatus: AvailabilityStatus.ACTIVE,
    notificationSnoozeStatus: NotificationSnoozeStatus.OFF,
    icon: ACTIVE_WITH_NOTIFICATIONS_ICON
  },
  {
    availabilityStatus: AvailabilityStatus.ACTIVE,
    notificationSnoozeStatus: NotificationSnoozeStatus.ON,
    icon: ACTIVE_WITHOUT_NOTIFICATIONS_ICON
  },

  {
    availabilityStatus: AvailabilityStatus.ON_CALL,
    notificationSnoozeStatus: NotificationSnoozeStatus.OFF,
    icon: ACTIVE_WITH_NOTIFICATIONS_ICON
  },
  {
    availabilityStatus: AvailabilityStatus.ON_CALL,
    notificationSnoozeStatus: NotificationSnoozeStatus.ON,
    icon: ACTIVE_WITHOUT_NOTIFICATIONS_ICON
  },
  {
    availabilityStatus: AvailabilityStatus.AWAY,
    notificationSnoozeStatus: NotificationSnoozeStatus.OFF,
    icon: AWAY_WITH_NOTIFICATIONS_ICON
  },
  {
    availabilityStatus: AvailabilityStatus.AWAY,
    notificationSnoozeStatus: NotificationSnoozeStatus.ON,
    icon: AWAY_WITHOUT_NOTIFICATIONS_ICON
  }
]

export const getStatusIcon = (availabilityStatus, notificationSnoozeStatus, isLimited) => {
  if (isLimited && availabilityStatus === AvailabilityStatus.ACTIVE) {
    return notificationSnoozeStatus === NotificationSnoozeStatus.ON ?
      AUTO_AWAY_WITHOUT_NOTIFICATIONS_ICON :
      AUTO_AWAY_WITH_NOTIFICATIONS_ICON
  }

  return AvailabilityStatusIcons.find(icon =>
    icon.availabilityStatus === availabilityStatus &&
    icon.notificationSnoozeStatus === notificationSnoozeStatus
  ).icon
}



// WEBPACK FOOTER //
// ./src/scripts/components/MainNav/NewAgentStatus/constants.js